import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";
class Unit_se {
    constructor() {
        this.entity = 'establishment';
    }

    delete(id) {
        return Api.delete(this.entity,id)
    }


    getById(id) {
        if(id && id.length>0) {
            return Api.getById(this.entity, id)
        }else {
            return Api.new_(this.entity)
        }
    }

    getPage(search,buildId,page_,size_) {
        let formData=new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        formData.append("search",search)
        formData.append("buildId",buildId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/list',
            headers: {'Content-Type': 'application/json'},
        })
    }
    save(model) {
        return Api.save(this.entity,model)
    }

    getUnits(buildingId){
        let formData=new FormData();
        formData.set("buildingId", buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/units/',
            headers: {'Content-Type': 'application/json'},
        })
    }
    saveInfo(model){
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: model,
            url: '/private/'+this.entity+'/saveInfo/',
            headers: {'Content-Type': 'application/json'},
        })
    }



    //----------------
    checkOut(unitName,buildingId){
        let formData=new FormData();
        formData.set("unitId",unitName)
        formData.set("buildingId", buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/checkOut/',
            headers: {'Content-Type': 'application/json'},
        })
    }




    changeStatus(model){
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:model,
            url: '/private/'+this.entity+'/changeStatus',
            headers: {'Content-Type': 'application/json'},
        })
    }
    //کاربران غیرفعال
    getPageInactive(page_,size_ ) {
        var formData = new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/listInactive/',
            headers: {'Content-Type': 'application/json'},
        })
    }


    getUserList(page_,size_ ,buildingId,unitName) {
    var formData = new FormData();
    formData.set("page",page_)
    formData.set("size", size_)
    formData.set("buildId", buildingId)
    formData.set("unitName", unitName)
    return BaseApi({requiresAtuh: true})({
        method: 'POST',
        data: formData,
        url: '/private/'+this.entity+'/listUser/',
        headers: {'Content-Type': 'application/json'},
    })
    }

    upload(file ,bId) {
        let formData = new FormData();
        formData.set("file",file)
        formData.set("bId",bId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/saveByExcel/',
            headers: {'Content-Type': 'application/json'},
        })
    }



}
export default new Unit_se();
